import axios from "axios";

import { GridTransactionInternal } from "types";
import {
  DataGridRequestParams,
  GridTransactionList,
} from "fe-shared-transactions/src/types";

import { PAGE_SIZE } from "consts";

export const getTransactions = (
  queryKey: string,
  requestParams: DataGridRequestParams,
  page: number | null = 1
) => {
  return axios
    .post<GridTransactionList<GridTransactionInternal>>("getTransactions", {
      ...requestParams,
      ...(page !== null
        ? { limit: PAGE_SIZE, skip: PAGE_SIZE * (page - 1) }
        : {}),
    })
    .then((res) => res.data);
};

export default getTransactions;
